import { createCookieName } from "./createCookieName";

export const saveToken = (session_token, expiration, user_uuid, service_uuid) => {
  const cookieName = createCookieName(user_uuid, service_uuid);
  const date = new Date(expiration);
  // console.log("cookieName", cookieName);
  document.cookie = `${cookieName}=${session_token}; path=/; expires=${String(date)}`;
};
